<template>
    <section id="nav">
        <div v-if="txt.range_calculator && txt.charging_simulator">
            <router-link :to="`/${lang}/${country}/autonomy`">
									<svg class="icon-navigation">
										<use xlink:href="#icon-Autonomie"></use>
									</svg>
									{{txt.range_calculator}}
						</router-link>   
            <router-link :to="`/${lang}/${country}/charge`">
								<svg class="icon-navigation">
									<use xlink:href="#icon-Charge"></use>
								</svg>
							{{txt.charging_simulator}}
					</router-link>
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      // RangeIsActive: true
    };
  },
  computed: {
    ...mapState({
      txt: state => state.txt.common,
      lang: state => state.lang,
      country: state => state.country
    })
  }
};
</script>